// ESM shim for underpub-js — the original module uses an IIFE that wraps
// module.exports, which @rollup/plugin-commonjs cannot statically analyze.
// This shim exposes the same API as a proper ES module default export.

const store = {};

const _remove = (e, index) => {
  const callbacks = store[e];
  store[e] = [];
  callbacks.forEach((cb, i) => {
    if (i !== index) store[e].push(cb);
  });
  return true;
};

const publish = function(e, args) {
  if (!store[e] || store[e].length === 0) return false;
  store[e].forEach(func => func.call(this, args));
  return true;
};

const subscribe = (e, callback) => {
  if (!store[e]) store[e] = [];
  store[e].push(callback);
  return [e, callback];
};

const unsubscribe = (e, callback) => {
  if (!store[e]) return true;
  store[e].forEach((cb, i) => {
    if (cb === callback) _remove(e, i);
  });
  return true;
};

const PubSub = { publish, subscribe, unsubscribe };

export default PubSub;
